module.exports = __webpack_public_path__ + "img/LYB.03a6273a.svg";